// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countdown-line[data-v-9c7961fa] {\n  font-size: 0.37333rem;\n  color: #000000;\n}\n.countdown-line .countdown-line-red[data-v-9c7961fa] {\n    color: #AE3118;\n}\n.pay-part[data-v-9c7961fa] {\n  width: 30%;\n  margin: 0 auto;\n}\n.btn-pay[data-v-9c7961fa] {\n  background-color: #005423;\n  color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
